/** 
 * 创建全局 eventBus
*/
import Vue from "vue"

export default new Vue();
